import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950/90 text-white py-12 border-t border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-3 bg-gradient-to-r from-cyan-300 via-teal-300 to-sky-400 bg-clip-text text-transparent">
              molelabs
            </h3>
            <p className="text-slate-400 text-sm">
              {t.footer.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-slate-400 hover:text-cyan-300 transition-colors duration-200 text-sm">
                  {t.nav.home}
                </a>
              </li>
              <li>
                <a href="#services" className="text-slate-400 hover:text-cyan-300 transition-colors duration-200 text-sm">
                  {t.nav.services}
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-slate-400 hover:text-cyan-300 transition-colors duration-200 text-sm">
                  {t.nav.portfolio}
                </a>
              </li>
              <li>
                <a href="#about" className="text-slate-400 hover:text-cyan-300 transition-colors duration-200 text-sm">
                  {t.nav.about}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-cyan-300 transition-colors duration-200 text-sm">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect</h4>
            <div className="flex gap-4">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-900 border border-slate-700 hover:border-cyan-400 hover:bg-cyan-500/20 rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-900 border border-slate-700 hover:border-cyan-400 hover:bg-cyan-500/20 rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="mailto:info@molelabs.eu"
                className="w-10 h-10 bg-slate-900 border border-slate-700 hover:border-cyan-400 hover:bg-cyan-500/20 rounded-full flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            {t.footer.rights.replace('2025', currentYear)}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
